import { usStatesValues } from 'constants/enums/usStates';
import { usTerritoriesPVQValues } from 'constants/enums/usTerritories';
import { notPOBoxPattern, zipCodePattern } from 'constants/patterns';
import { ValidateJSModel, LocationModel } from 'forms/shared/types';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';

export const pvqEvictionLocationValidator: ValidateJSModel<LocationModel> = {
  ...pvqLocationModelValidator,
  street: {
    presence: true,
    format: { pattern: notPOBoxPattern, flags: 'i', message: 'error.location.street.poBox.pattern' },
  },

  state: {
    presence: true,
    inclusion: {
      within: [...usStatesValues, ...usTerritoriesPVQValues],
      message: 'error.state.notfound',
    },
  },

  zipcode: {
    presence: true,
    format: { pattern: zipCodePattern, message: 'error.zipcode.pattern' },
  },

  country: {},
};
